import React from 'react'

export const About = () => {
  return (
    <div className="about">
        <div className="title">About Me</div>
        <p>I am a software engineer with a passion for creating innovative solutions. I have a strong background in software development and have worked on a variety of projects, from small business websites to large enterprise applications.</p>
        <div className="details">
            <div className="detail">Name <span>Antony Karanja</span></div>
            <div className="detail">Phone <span>+254 740 105 052</span></div>
            <div className="detail">Nationality <span>Kenyan</span></div>
            <div className="detail">Languages <span>Swahili, English</span></div>
            <div className="detail">Freelance <span>Available</span></div>
            <div className="detail">Address <span>Nairobi, Kenya</span></div>
            <div className="detail">Email <span>antonykaranja837@gmail.com</span></div>
            
        </div>

    </div>
  )
}
